import { render, staticRenderFns } from "./historyOrders.vue?vue&type=template&id=33cc59d7&scoped=true&"
import script from "./historyOrders.vue?vue&type=script&lang=js&"
export * from "./historyOrders.vue?vue&type=script&lang=js&"
import style0 from "./historyOrders.vue?vue&type=style&index=0&id=33cc59d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc59d7",
  null
  
)

export default component.exports